<template>
  <div >
    <div v-for="alert in alerts" v-bind:key="alert.id" :class="[alert.status==='success' ? 'alert-success' : 'alert-danger', 'alert']">
        {{ alert.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "app-alert",
  computed: {
    alerts() {
      return this.$store.getters.getAlerts;
    },
  },
};
</script>

<style scoped>
.alert{
  text-align: center;
}
</style>
